import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the Coach Reporting page — gradient header, a row of
// scorecard stat cards, then a couple of collapsible report section panels.
export default function CoachReportingSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border p-4 ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200 shadow-sm"}`;
    const panelCls = `rounded-2xl border p-5 ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200 shadow-sm"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-5xl mx-auto px-4 py-8">
                    <div className="mb-8"><Skeleton height={112} borderRadius={16} /></div>

                    {/* Scorecard stat cards */}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
                        {Array.from({ length: 4 }).map((_, i) => (
                            <div key={i} className={cardCls}>
                                <Skeleton width={36} height={36} borderRadius={10} className="mb-3" />
                                <Skeleton width={56} height={24} />
                                <Skeleton width={80} height={12} className="mt-1" />
                            </div>
                        ))}
                    </div>

                    {/* Report section panels */}
                    {Array.from({ length: 2 }).map((_, p) => (
                        <div key={p} className={`${panelCls} mb-6`}>
                            <div className="flex items-center justify-between mb-4">
                                <Skeleton width={180} height={20} />
                                <Skeleton width={80} height={16} />
                            </div>
                            <div className="space-y-2.5">
                                {Array.from({ length: 5 }).map((_, r) => (
                                    <div key={r} className="grid grid-cols-4 gap-4 items-center">
                                        <Skeleton height={14} width="80%" />
                                        <Skeleton height={14} width="60%" />
                                        <Skeleton height={14} width="60%" />
                                        <Skeleton height={14} width="50%" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </SkeletonTheme>
    );
}
